import ProcurementsDetailsPageHeader from './ProcurementsDetailsPageHeader';
import ProcurementsDetails from './ProcurementsDetails';
import AddProductModal from './AddProductModal';
import AddTagModal from './AddTagModal';
import { AddTagModalTableColumn } from './AddTagModal/AddTagModalTableColumn';
import AddProductBatch from '../../CreateProductBatch';

export {
  ProcurementsDetailsPageHeader,
  ProcurementsDetails,
  AddProductModal,
  AddTagModal,
  AddTagModalTableColumn,
  AddProductBatch,
};
